import React, { useState } from "react";
import { Box, Stack, Typography } from "@mui/material";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import EventNoteIcon from "@mui/icons-material/EventNote";
// GroupsIcon only backed the now-disabled "Team Leave Calendar" quick link
// below -- restore this import alongside it if that link comes back.
// import GroupsIcon from "@mui/icons-material/Groups";
import { useHistory } from "react-router-dom";
import { leavePalette, cardSx } from "./leaveHelpers";
import { LeaveDetailsDrawer } from "../../MyLeaves/LeaveDetailsDrawer";

// Quick Links — horizontal bar (matches My Requests home). "Leave Balance
// Details" opens the slide-in Leave Details drawer (action) instead of
// navigating; the others navigate (Leave Policy has no route/page yet, so it
// renders inert — "link what exists" scope).
const quickLinks = [
  { label: "Leave Balance Details", icon: EventNoteIcon, action: "leaveDetails" },
  { label: "Leave Policy", icon: DescriptionOutlinedIcon, path: null },
  { label: "Holiday Calendar", icon: CalendarMonthIcon, path: "/admin/myzone/calendar" },
  // Team Leave Calendar temporarily disabled (2026-09-16, per request) -- the
  // screen isn't needed right now. It also has no real route wired up
  // (/admin/teamzone/calendar isn't in routes.js's flat top-level route list,
  // so clicking this today silently falls through to the catch-all redirect
  // in Admin.js instead of rendering TeamZoneCalendar), so nothing else
  // depends on this entry. Restore by uncommenting once the screen is wanted
  // again -- routes.js will also need a real top-level route added for it.
  // { label: "Team Leave Calendar", icon: GroupsIcon, path: "/admin/teamzone/calendar" },
];

export const LeaveSummaryPanel = () => {
  const history = useHistory();
  const [detailsOpen, setDetailsOpen] = useState(false);

  return (
    <Box sx={{ ...cardSx, p: 2 }}>
      <Stack
        direction={{ xs: "column", md: "row" }}
        alignItems={{ xs: "flex-start", md: "center" }}
        spacing={{ xs: 1.5, md: 3 }}
      >
        <Typography fontWeight={700} sx={{ color: leavePalette.text, flexShrink: 0 }}>
          Quick Links
        </Typography>
        <Stack
          direction="row"
          flexWrap="wrap"
          alignItems="center"
          sx={{ rowGap: 1.5, columnGap: { xs: 2, md: 4 } }}
        >
          {quickLinks.map((q) => {
            const Icon = q.icon;
            const clickable = Boolean(q.path || q.action);
            return (
              <Stack
                key={q.label}
                direction="row"
                alignItems="center"
                spacing={1}
                onClick={() => {
                  if (q.action === "leaveDetails") setDetailsOpen(true);
                  else if (q.path) history.push(q.path);
                }}
                sx={{
                  cursor: clickable ? "pointer" : "default",
                  opacity: clickable ? 1 : 0.55,
                  color: leavePalette.text,
                  transition: "color .15s ease",
                  "&:hover": clickable ? { color: leavePalette.blue } : undefined,
                  "&:hover .qlIcon": clickable ? { color: leavePalette.blue } : undefined,
                }}
              >
                <Icon className="qlIcon" sx={{ color: leavePalette.subText, fontSize: 20 }} />
                <Typography variant="body2" fontWeight={500} sx={{ color: "inherit" }}>
                  {q.label}
                </Typography>
              </Stack>
            );
          })}
        </Stack>
      </Stack>

      <LeaveDetailsDrawer open={detailsOpen} onClose={() => setDetailsOpen(false)} />
    </Box>
  );
};
